import { Component, Inject, OnDestroy, OnInit, Optional, SecurityContext, ViewChild } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogConfig,
} from '@angular/material/dialog';
import { CashierConfirmationComponent } from 'src/app/common/components/cashier-confirmation/cashier-confirmation.component';
import { ApiService } from 'src/app/common/services/api.service';
import { MessageService } from 'src/app/common/services/message.service';
import { CurrencyService } from 'src/app/util/currency.service';
import { UtilService } from 'src/app/util/util.service';
import { CashierActionType } from '../../models/enums/invoice.enum'; 
import { CROSS, CASH_TALLY } from 'src/defaultImages.js';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { BillingCountersDataService } from 'src/app/common/services/billing-counters-data.service';


@Component({
  selector: 'app-cash-tally',
  templateUrl: './cash-tally.component.html',
  styleUrls: [
    '../../../common/components/update-cash/update-cash.component.css',
  ],
})
export class CashTallyComponent implements OnInit, OnDestroy {
  images = { 
    CROSS: CROSS,
    CASH_TALLY: CASH_TALLY
  }
  Currency;
  callManagerVerification: boolean = false;
  subscription: Subscription = new Subscription();
  translationText:any;
  billingCounterName: string = '';
  billingCounterInfo: string = '';
  // cashNotTalliedData = [
  //   {name: 'EXPECTED CASH IN DRAWER', amount: 230},
  //   {name: 'ACTUAL CASH IN DRAWER', amount: 230},
  //   {name: 'EXCESS/SHORT CASH', amount: 230},
  // ];
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: true,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      width: '66px',
      height: '66px',
    },
    inputMode: 'numeric',
  };
  otp: string = '';
  showOtpComponent = true;
  pinAuthLifecycle = {
    reset: true,
    success: false,
    wrong: false,
  };
  runningAnimation: string = '';

  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<CashierConfirmationComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService,
    private messageService: MessageService,
    private _util: UtilService,
    private curr: CurrencyService,
    private _translateService: TranslateService,
    private _sanitizer: DomSanitizer,
    private _counterDataService: BillingCountersDataService
  ) {
    this.Currency = this.curr.getCurrency();
  }

  ngOnInit() {
    this.setTranslations();
    this.getBillingCounterName();
  }
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private getBillingCounterName(): void {
    this.subscription.add(
      this._counterDataService
        .getMappedBillingCounterName()
        .subscribe((mappedCounterName) => {
          this.billingCounterName = mappedCounterName;
          if (this.billingCounterName) {
            this.setSubHeading('CLOSING_CASHIER');
          }
        })
    );
  }

  cancelClicked() {
    this.dialogRef.close({ data: 'closed' });
  }

  onOtpChange(otp) {
    if ((this.otp || '').length !== otp.length) {
      if (otp.length === 4) {
        this.verifyStaffPin(otp);
      } else if (otp.length === 0) {
        this.onConfigChange();
        this.pinAuthLifecycle = {
          reset: true,
          success: false,
          wrong: false,
        };
      }
    }

    this.otp = otp;
  }

  onConfigChange() {
    this.showOtpComponent = false;
    this.otp = null;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }

  forceCloseCashier(staffCredential) {
    let payload = this.data.closeCashierPayload;
    payload['force_close'] = 1;
    payload['user_id'] = staffCredential.user_id;
    payload['device_id']= this._util.getDeviceUID();
    this.apiService.addCashDetails(payload).subscribe(
      (response) => {
        if (
          response.statusCode === 201 &&
          (response.data || {}).cash_tallied === 1
        ) {
          if (this._util.cashRegistryEnabled()) {
            const isMultiCashDrawerEnabled = this._util.isMultiCashDrawerEnabled();
            const deviceId = this._util.getDeviceUID();
            const data = {
              restaurant_id: this.data.restaurant_id,
              txn_id: response.data.txn_id,
              action: this.data.type,
              ...(isMultiCashDrawerEnabled && { device_id: deviceId }),
            };
            this._util.send_data_to_react(data, this.data.type);
            if (this.data.type !== CashierActionType.closeCashier) {
              this._util.openCashDrawer();
            }
            this._util.openCashDrawerPrintReceipt(
              {
                restaurant_id: this.data.restaurant_id,
                txn_id: response.data.txn_id,
              },
              this.data.type
            );
          }
          this.messageService.showSuccess(response.data.message);
          this.openCashierReportModal(staffCredential.token);
          this.dialogRef.close({ data: 'force_cash_tallied' });
        }
      },
      (error) => {
        this.messageService.showError(error.error.message);
        this.onConfigChange();
        this.pinAuthLifecycle = {
          reset: true,
          success: false,
          wrong: false,
        };
      }
    );
  }

  verifyStaffPin(pin) {
    const payload = {
      restaurant_id: this.data.restaurant_id,
      staff_cred: pin,
    };

    this.apiService.verifyStaff(payload).subscribe(
      (response) => {
        if (response.status == 1) {
          if (
            response.role === 'rest_admin' ||
            (response.roles || []).includes('manager') ||
            (response.roles || []).includes('owner')
          ) {
            this.pinAuthLifecycle = {
              reset: false,
              success: true,
              wrong: false,
            };
            this.forceCloseCashier(response);
            // this.openCashierReportModal(response.token);
            // this.dialogRef.close({ data: "force_cash_tallied" });
          } else {
            this.invalidCredential();
          }
        } else {
          this.invalidCredential();
        }
      },
      (error) => {
        this.invalidCredential();
      }
    );
  }

  invalidCredential() {
    this.pinAuthLifecycle = {
      reset: false,
      success: false,
      wrong: true,
    };
    this.runningAnimation = 'miss';
    setTimeout(() => {
      this.runningAnimation = '';
    }, 500);
  }

  openCashierReportModal(token) {
    const dialogConfig = new MatDialogConfig();
    const dialogRef = this.dialog.open(CashierConfirmationComponent, {
      backdropClass: 'backdrop',
      maxHeight: '90vh',
      data: {
        type: 'cashier-report',
        restaurant_id: this.data.restaurant_id,
        cashTally: 1,
        authToken: token,
      },
      maxWidth: '100vw',
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.dialogRef.close({ data: 'closed' });
    });
  }

  private setTranslations(){
    this.subscription.add(
      this._translateService.get('REPORTS').subscribe((translations) => {
        this.translationText = translations || {};
      })
    )
  }
  private setSubHeading(translationString: string): void {
    const counterSubHeading = this.translationText[translationString]?.replace(
      '{{billingCounterName}}',
      this.billingCounterName
    );
    this.sanitizeHtml(counterSubHeading);
  }
  private sanitizeHtml(html: string): void {
    this.billingCounterInfo = this._sanitizer.sanitize(
      SecurityContext.HTML,
      html
    );
  }
}
